import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { FiX } from "react-icons/fi";
import { createPortal } from "react-dom";
import { useAuth } from "../../context/AuthContext"; // sesuaikan path

export default function FormDataMapel({ open, onClose, onSuccess, data }) {
  const { token } = useAuth(); // ← pakai session token

  const [kodeMapel, setKodeMapel] = useState("");
  const [namaMapel, setNamaMapel] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (data) {
      setKodeMapel(data.kode_mapel || "");
      setNamaMapel(data.nama_mapel);
    } else {
      setKodeMapel("");
      setNamaMapel("");
    }
  }, [data]);

  if (!open) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!namaMapel.trim()) {
      toast.warning("Nama mapel wajib diisi");
      return;
    }

    try {
      setLoading(true);

      if (data) {
        await axios.put(
          `https://backend.smpn1kamal.sch.id/api/datamapel/${data.id_mapel}`,
          { nama_mapel: namaMapel, kode_mapel: kodeMapel },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        toast.success("Mapel berhasil diperbarui");
      } else {
        await axios.post(
          "https://backend.smpn1kamal.sch.id/api/datamapel",
          { nama_mapel: namaMapel, kode_mapel: kodeMapel },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        toast.success("Mapel berhasil ditambahkan");
      }

      onSuccess();
      onClose();
    } catch (err) {
      toast.error(err.response?.data?.message || "Gagal menyimpan mapel");
    } finally {
      setLoading(false);
    }
  };

  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 px-3">
      <div className="bg-white w-full sm:max-w-md rounded-xl shadow p-5 relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-slate-500 hover:text-red-500"
        >
          <FiX size={20} />
        </button>

        <h2 className="text-xl font-semibold mb-4 text-indigo-600">
          {data ? "Edit Mapel" : "Tambah Mapel"}
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            placeholder="Kode Mapel (opsional)"
            value={kodeMapel}
            onChange={(e) => setKodeMapel(e.target.value)}
            className="w-full border rounded-lg px-3 py-2 text-sm"
          />

          <input
            type="text"
            placeholder="Nama Mapel"
            value={namaMapel}
            onChange={(e) => setNamaMapel(e.target.value)}
            className="w-full border rounded-lg px-3 py-2 text-sm"
          />

          <div className="flex justify-end gap-2 pt-2">
            <button type="button" onClick={onClose} className="px-4 py-2 border rounded-lg text-sm">
              Batal
            </button>
            <button
              type="submit"
              disabled={loading}
              className="px-4 py-2 bg-indigo-500 text-white rounded-lg text-sm"
            >
              {loading ? "Menyimpan..." : "Simpan"}
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
}